module.exports = __webpack_public_path__ + "0596a732a08ce732e47d953abc6657fe.jpg";